<template>
    <div class="main-section" v-if="loading">
        <div class="inner">
            <div class="main-section-head">
                <div class="left">
                    <h3 class="title"><i class="icon-building icon-building--home"></i>베스트 <b>{{ category.name }}</b></h3>
                    <ul class="tab-lists">
                        <li><button class="button" type="button" @click="filter._category = category_id;" :aria-pressed="filter._category == category_id">전체</button></li>
                        <li v-for="subCategory in category.children" :key="subCategory._id"><button class="button" type="button" @click="filter._category = subCategory._id;" :aria-pressed="filter._category == subCategory._id">{{ subCategory.name }}</button></li>
                    </ul>
                </div>
                <div class="right">
                    <a class="link" :href="`${path}`"><span>+ 더보기</span></a>
                </div>
            </div>
            <div class="main-section-body">
                <div :class="`main-interiors main-interiors--${category.code}`">
                    <div class="swiper-container">
                        <div class="swiper-wrapper">
                            <div class="swiper-slide" v-for="(item, index) in portfolios" :key="index">
                                <router-link :to="`${path}/${item._id}`" class="interior-list">
                                    <span class="interior-list__thumb">
                                        <span class="interior-list__thumbnail">
                                            <!-- <span class="interior-list__thumbnail-image" :style="backImage(item)"></span> -->
                                            <span :data-background="item.thumb" class="interior-list__thumbnail-image swiper-lazy"></span>
                                            <div class="swiper-lazy-preloader"></div>
                                        </span>
                                        <span class="interior-list__thumb-image"></span>
                                    </span>
                                    <span class="interior-list__badge">{{ index+1 }}</span>
                                    <span class="interior-list__title">{{ item.subject }}</span>
                                    <ul class="interior-list__infos">
                                        <li class="interior-list__info">{{ item.category.name }}</li>
                                        <li class="interior-list__info">{{ item.construction.acreage.format() }}평대</li>
                                        <li v-if="item.user" class="interior-list__info">{{ item.user.meta.companyName }}</li>
                                    </ul>
                                </router-link>
                            </div>
                        </div>
                    </div>
                    <div class="main-interiors__pagination"></div>
                    <div class="main-interiors__prev"></div>
                    <div class="main-interiors__next"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import api from "@/api";

export default {
    props : {
        category_id: { type: String, default: "5fae46e6dc19c41f74a85f04" },
    },
    computed: {
        path() {
            if (this.category?.name == "주거공간") return "/portfolio/resident";
            if (this.category?.name == "상업공간") return "/portfolio/industry";
            return "/portfolio/partial";
        },
    },
    data(){
        return {
            filter: {
                main: true,
                _category: null,
            },

            loading : false,
            component : null,

            category : null,
            menu : "",

            portfolios : null,
            swiper : null
        }
    },
    mounted() {
        this.component = this;
        this.filter._category = this.category_id;
        this.init();
    },
    methods : {
        // backImage(item) {
        //     return {
        //         'backgroundImage' : `url('res/portfolio/${item._id}/${item.thumb.filename}')`
        //     }
        // },
        settingSlide() {
            this.$nextTick( () => {
                    this.swiper = new Swiper(`.main-interiors--${this.category.code} .swiper-container`, {
                    allowTouchMove: true,
                    spaceBetween : 35,
                    slidesPerView: 3,
                    slidesPerGroup: 3,
                    speed: 300,
                    loop: false,
					watchSlidesVisibility: true,
					preloadImages: false,
					lazy: true,
                    pagination: {
                        el: `.main-interiors--${this.category.code} .main-interiors__pagination`,
                        clickable: true,
                    },
                    navigation: {
                        nextEl: `.main-interiors--${this.category.code} .main-interiors__next`,
                        prevEl: `.main-interiors--${this.category.code} .main-interiors__prev`
                    },
                    breakpoints: {
                        768: {
                            slidesPerView: 2,
                            slidesPerGroup: 2,
                            spaceBetween : 10,
							lazy: {
								loadPrevNext: true,
								loadPrevNextAmount: 1,
							},
                        },
                        1024: {
                            spaceBetween : 10,
							lazy: {
								loadPrevNext: true,
								loadPrevNextAmount: 1,
							},
                        }
                    }
                });
            });
        },
        async init() {
            try {
                var { category } = await api.v1.portfolios.categories.getCategory({ _id: this.filter._category });
                this.category = category;

                var { portfolios } = await api.v1.portfolios.getPortfolios({ headers: { skip: 0, limit: 5 }, params: this.filter });
                this.portfolios = portfolios;

                this.loading = true;
                this.settingSlide();
            }catch(error) {
                console.error(error);
            }
        },
    },
    watch : {
        async "filter._category"() {
            var { portfolios } = await api.v1.portfolios.getPortfolios({ headers: { skip: 0, limit: 5 }, params: this.filter });
            this.portfolios = portfolios;
            this.settingSlide();
        }
    }
}
</script>
